import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './AuthProvider.tsx';

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth se ha usado fuera de <AuthProvider>');
  }
  return context;
}
